import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.by{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ax{max-width:77.5rem;}.ssr-plugin'
import '.cp{justify-content:stretch;}.ssr-plugin'
import '.cq{position:sticky;}.ssr-plugin'
import '.cf{top:0;}.ssr-plugin'
import '.cr{z-index:10;}.ssr-plugin'
import '.cs{padding-block:1rem;}.ssr-plugin'
import '.ct{height:3rem;}.ssr-plugin'
import '.a8{justify-content:space-between;}.ssr-plugin'
import '.cu{flex-wrap:wrap;}.ssr-plugin'
import '.cv{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.av{margin-top:2rem;}.ssr-plugin'
import '.gk{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab g b co"
      >
        <div className="by a c g b"
        >
          <div className="ax a b cp cq cf cr"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cs ct a a8 c cu"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="cv a b ab av gk ax"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
